exports = module.exports = require("../../../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "html[dir] ._3EJsfbZ6d7freE735vpYNF{-webkit-box-shadow:0 -2px 1px -2px \"[theme:neutralDark, default:#212121]\";box-shadow:0 -2px 1px -2px \"[theme:neutralDark, default:#212121]\"}._2YAgUl4_gtnvwlFNLThd0P{position:fixed;pointer-events:\"none\";z-index:1000;top:0;font-size:12px;font-weight:400}html[dir] ._2YAgUl4_gtnvwlFNLThd0P{border-width:1px;border-style:solid;padding:0 4px;background-color:\"[theme:white, default:#ffffff]\"}html[dir=ltr] ._2YAgUl4_gtnvwlFNLThd0P{left:0}html[dir=rtl] ._2YAgUl4_gtnvwlFNLThd0P{right:0}", ""]);

// exports
exports.locals = {
	"showBorderOnDroppedOver": "_3EJsfbZ6d7freE735vpYNF",
	"dragHelperStyle": "_2YAgUl4_gtnvwlFNLThd0P"
};